exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button[data-v-683dc7e2]:disabled{opacity:.6}button[data-v-683dc7e2]:disabled:hover{background-color:#cf004a;color:#fff;border-color:#cf004a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-683dc7e2","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/medical-results/external-documentation-data-form.vue
// module id = 857
// module chunks = 0